// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onedocai {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.onedocai > .chat-sidebar {
  max-width: 280px;
  width: 100%;
  height: calc(100vh - 60px);
  /* z-index: 99 for now updating to 98 because workspace sidebar should come over ai sidebar if both are present but this is also a random number. Right solution would be to define a set of z-index and use them accordingly */
  z-index: 98;
  background-color: var(--box-background-color);
  border-right: 1px solid var(--toolbar-button-hover);
  overflow-x: hidden;
}
.chat-item:hover > .delete-button {
  display: block;
}

.chat-item > .delete-button {
  display: none;
}

.chat-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.chat-item > span {
  display: inline-block;
  flex: 1;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
}

.chat-sidebar .chat-sidebar-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 8px;
  padding-right: 8px;
  gap: 0.5rem;
}

.onedocai > .main-chat-window {
  position: relative;
  background-color: #fff;
  height: 100%;
}

.onedocai > .main-chat-window .chat-window-wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow-y: auto;
  position: relative;
  background-color: #fff;
}

.onedocai .chat-window {
  width: 100%;
}

.onedocai .chat-window-inner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

/* editor css */

.onedocai-editor {
  --tw-shadow: 0 0px 2px 6px rgba(0, 0, 0, 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  --tw-ring-shadow: 0 0 #000000;
  --tw-ring-offset-shadow: 0 0 #000000;
  width: 100%;
}

.onedocai-editor .onedocai-editor-inner {
  animation-duration: 0.2s;
  transition-duration: 0.2s;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.15s;
  outline: 2px solid transparent;
  border: 2px solid #1677ff;
  outline-offset: 2px;
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    0 0px 2px 2px rgba(0, 0, 0, 0.05);
  padding: 0.8rem;
  background-color: #fff;
  padding-right: 15px;
}

.onedocai-editor .onedocai-editor-inner:focus-within {
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    0 0px 2px 6px rgba(0, 0, 0, 0.05) !important;
}

.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutTop {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutTop .svg-icon-wrapper,
.prompt-answer-box .svg-icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
}

.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutTop .audio-icon-wrapper {
  align-self: flex-start;
  margin-right: 0.25rem;
  margin-top: 0.25rem;
}

.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutTop .svg-icon,
.prompt-answer-box .svg-icon {
  display: inline-block;
  stroke: var(--primary-font-color) !important;
}

.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutTop-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}

.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutBottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.onedocai-editor_layoutBottom .action-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.onedocai-editor .onedocai-editor-inner textarea {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background-color: transparent !important;
  padding-left: 0 !important;
  font-size: 0.9rem !important;
  font-weight: 400 !important;
}

/* prompt answer box */

.prompt-answer-box .prompt-answer_layoutTop {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.prompt-answer-box,
.prompt-question-box {
  color: var(--primary-font-color);
  font-size: 0.9rem;
}

.prompt-answer-box {
  border-radius: 0.375rem;
  margin-bottom: 2rem;
}

.prompt-answer-box:last-child {
  margin-bottom: 0 !important;
}

.prompt-answer-box .prompt-answer-feedback {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

/* .prompt-question-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
} */

.prompt-question-box .go-back-btn {
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  border-radius: 50%;
  margin-right: 0.5rem;
  margin-top: 0.5rem;
}

.prompt-question-box .user-avatar {
  width: 32px;
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: 1rem;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
  margin-top: 0.25rem;
}

.prompt-question-box .prompt-question {
  max-width: max-content;
  justify-self: flex-end;
  background-color: var(--tertiary-font-color);
  padding: 0.75rem 1rem;
  border-radius: 1rem;
}

.interactive-prompt {
  width: 100%;
  margin-bottom: 1rem;
}

/* sidebar css */

.onedocai .ai-sidebar {
  max-width: 300px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  max-height: 100vh;
  background-color: var(--sidemenu-background-color);
}

.ai-sidebar .ai-sidebar-top {
  padding: 1rem;
}

.ai-sidebar .new-chat-btn {
  width: 100%;
  font-family: 'Inter', sans-serif;
}

/* new chat window */

.new-chat-window {
  user-select: none;
}

.interactive-answer.error .main-ai-response p {
  margin: 0;
  color: rgb(161, 22, 22) !important;
  text-align: center;
}

.interactive-answer.error {
  background-color: rgba(255, 0, 0, 0.1);
  color: red;
  border-radius: 0.25rem;
  padding: 0.5rem 1rem 0.5rem 1rem;
}

.interactive-answer.error .main-ai-response {
  margin-bottom: 0rem !important;
}

.new-chat-window .new-chat-window-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.new-chat-window .chat-window-header {
  padding-left: 0.5rem;
  padding-left: 0.5rem;
}

.new-chat-window .chat-window-action {
  padding: 0.25rem 0.5rem;
  border-radius: 1rem;
  margin-bottom: 0.25rem;
  transition: all 250ms ease-in-out;
  cursor: pointer;
}

.new-chat-window .chat-window-body h4 {
  color: #000000;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-bottom: 0.5rem;
  text-align: left;
  padding-top: 48px;
}

.chat-window-action .chat-window-action__layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
  font-size: 0.85rem;
  font-weight: 500;
}

.new-chat-window .chat-window-action:hover {
  background-color: var(--tertiary-font-color);
}

.onedocai .main-chat-window {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
}

.prompt-box-wrapper {
  padding-bottom: 3rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

/* onedoc sidebar all chats */
.all-chats-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  max-width: 200px;
  line-height: 0.8rem;
}

.all-chats-drawer .ant-drawer-body {
  padding: 0.5rem 1rem;
}

.all-chats-drawer .all-chats-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.75rem;
}

.all-chats-drawer .all-chats-header h3 {
  margin: 0;
}

.responsive-chat-layout {
  width: 100%;
  height: 100%;
  max-width: 700px;
  padding-left: 1rem;
  padding-right: 1rem;
}

.chat-menu-item {
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
}

.chat-menu-item__inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: space-between;
  gap: 0.25rem;
}

.chat-menu-item__inner .menu-item-icon {
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.chat-menu-item__inner .menu-item-label {
  text-overflow: ellipsis;
  text-wrap: nowrap;
  overflow: hidden;
  flex: 1;
}

.chat-menu-item__inner .menu-item-actions {
  display: none;
}
.chat-menu-item:hover {
  background-color: var(--tertiary-font-color);
}

.chat-menu-item:hover .menu-item-actions {
  display: block;
}

.menu-item-actions .action-btn {
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

/* onedocai header */

.onedocai .onedocai-header {
  padding: 0.5rem 1rem;
}

/* onedocai response css */
.prompt-answer-box .prompt-answer .main-ai-response {
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-bottom: 0.75rem;
}

.prompt-answer-box .prompt-answer .sources-list {
  margin-top: 0;
}

.prompt-answer-box .prompt-answer .source-item p {
  font-family: 'Inter', sans-serif;
  margin: 0.25rem 0;
  line-height: 1.4;
}

.prompt-answer-box .prompt-answer .source-item .source-item-link {
  display: inline-block;
  background-color: var(--tertiary-font-color);
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 0.8rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.context-file-selector .dropdown-content {
  position: absolute;
  bottom: 40px;
  right: 0px;
  min-width: 180px;
  max-width: 180px;
  background-color: var(--tertiary-font-color) !important;
  border-radius: 4px;
}

.context-file-selector .dropdown-content .node {
  background-color: var(--tertiary-font-color) !important;
}

.context-file-selector .dropdown-trigger.arrow {
  padding: 0.062rem 0.25rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  border-radius: 0.25rem;
  background-color: var(--tertiary-font-color);
  justify-content: flex-start;
}

.context-file-selector .dropdown .dropdown-trigger.arrow::after {
  font-size: 8px;
  border-color: var(--editor-text-font-color) !important;
  color: var(--editor-text-font-color) !important;
}

.context-file-selector .tag-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.tag-list .tag {
  text-wrap: nowrap;
}

.context-file-selector .dropdown-trigger input[type='text'] {
  display: none;
}
.context-file-selector .dropdown-trigger .tag-item {
  margin: 0;
  margin-right: 4px;
}

.context-file-selector .tag {
  background-color: var(--tag-onsurface-background-color);
  padding: 0 0.125rem;
  color: var(--editor-heading-font-color);
  font-size: 13px;
  font-weight: 500;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.context-file-selector .tag button {
  font-size: 14px;
}

.context-file-selector .dropdown-trigger .tag-item:last-of-type:after {
  content: 'Select context';
  text-wrap: nowrap;
  font-size: 13px;
  font-weight: 500;
  color: var(--editor-text-font-color);
}
.prompt-answer_layoutBottom .remirror-editor {
  font-size: 14px;
}
.prompt-answer_layoutBottom table {
  width: 100% !important;
}

.ai-markdown table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1em;
  font-size: 14px;
}

.ai-markdown th,
.ai-markdown td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.ai-markdown th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.ai-markdown tr:nth-child(even) {
  background-color: #fafafa;
}
.prompt-question-box {
  display: flex;
  justify-content: flex-end;
  padding: 4px 0;
}

.chat-bubble-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: 100%;
  width: fit-content;
}

.chat-bubble {
  background-color: #f2f2f2;
  padding: 12px 16px;
  border-radius: 16px;
  font-size: 16px;
  line-height: 1.5;
  color: #000;
  display: inline-block;
  max-width: 100%;
  white-space: pre-wrap;
  max-width: 600px;
  width: auto;
}

/* Chat actions under the bubble */
.chat-actions {
  margin-top: 4px;
  display: flex;
  /* gap: 4px; */
}
`, "",{"version":3,"sources":["webpack://./src/pages/Ai/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,+NAA+N;EAC/N,WAAW;EACX,6CAA6C;EAC7C,mDAAmD;EACnD,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,OAAO;EACP,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;;AAEf;EACE,8CAA8C;EAC9C,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB;;;qCAGmC;EACnC,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;;;gDAG8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,wCAAwC;EACxC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;;;;;;GAMG;;AAEH;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,4CAA4C;EAC5C,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA,oBAAoB;;AAEpB;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,UAAU;EACV,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;AACf;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oBAAoB;;AAEpB;EACE,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uDAAuD;EACvD,kBAAkB;AACpB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,sDAAsD;EACtD,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,uDAAuD;EACvD,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,aAAa;EACb,cAAc;AAChB","sourcesContent":[".onedocai {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.onedocai > .chat-sidebar {\n  max-width: 280px;\n  width: 100%;\n  height: calc(100vh - 60px);\n  /* z-index: 99 for now updating to 98 because workspace sidebar should come over ai sidebar if both are present but this is also a random number. Right solution would be to define a set of z-index and use them accordingly */\n  z-index: 98;\n  background-color: var(--box-background-color);\n  border-right: 1px solid var(--toolbar-button-hover);\n  overflow-x: hidden;\n}\n.chat-item:hover > .delete-button {\n  display: block;\n}\n\n.chat-item > .delete-button {\n  display: none;\n}\n\n.chat-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.chat-item > span {\n  display: inline-block;\n  flex: 1;\n  text-overflow: ellipsis;\n  text-wrap: nowrap;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.chat-sidebar .chat-sidebar-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: end;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  padding-left: 8px;\n  padding-right: 8px;\n  gap: 0.5rem;\n}\n\n.onedocai > .main-chat-window {\n  position: relative;\n  background-color: #fff;\n  height: 100%;\n}\n\n.onedocai > .main-chat-window .chat-window-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  overflow-y: auto;\n  position: relative;\n  background-color: #fff;\n}\n\n.onedocai .chat-window {\n  width: 100%;\n}\n\n.onedocai .chat-window-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.h-full {\n  height: 100%;\n}\n\n/* editor css */\n\n.onedocai-editor {\n  --tw-shadow: 0 0px 2px 6px rgba(0, 0, 0, 0.05);\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\n  --tw-ring-shadow: 0 0 #000000;\n  --tw-ring-offset-shadow: 0 0 #000000;\n  width: 100%;\n}\n\n.onedocai-editor .onedocai-editor-inner {\n  animation-duration: 0.2s;\n  transition-duration: 0.2s;\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 0.15s;\n  outline: 2px solid transparent;\n  border: 2px solid #1677ff;\n  outline-offset: 2px;\n  box-shadow:\n    var(--tw-ring-offset-shadow, 0 0 #0000),\n    var(--tw-ring-shadow, 0 0 #0000),\n    0 0px 2px 2px rgba(0, 0, 0, 0.05);\n  padding: 0.8rem;\n  background-color: #fff;\n  padding-right: 15px;\n}\n\n.onedocai-editor .onedocai-editor-inner:focus-within {\n  box-shadow:\n    var(--tw-ring-offset-shadow, 0 0 #0000),\n    var(--tw-ring-shadow, 0 0 #0000),\n    0 0px 2px 6px rgba(0, 0, 0, 0.05) !important;\n}\n\n.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutTop {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutTop .svg-icon-wrapper,\n.prompt-answer-box .svg-icon-wrapper {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  align-self: flex-start;\n}\n\n.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutTop .audio-icon-wrapper {\n  align-self: flex-start;\n  margin-right: 0.25rem;\n  margin-top: 0.25rem;\n}\n\n.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutTop .svg-icon,\n.prompt-answer-box .svg-icon {\n  display: inline-block;\n  stroke: var(--primary-font-color) !important;\n}\n\n.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutTop-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.5rem;\n}\n\n.onedocai-editor .onedocai-editor-inner .onedocai-editor_layoutBottom {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.onedocai-editor_layoutBottom .action-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.onedocai-editor .onedocai-editor-inner textarea {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background-color: transparent !important;\n  padding-left: 0 !important;\n  font-size: 0.9rem !important;\n  font-weight: 400 !important;\n}\n\n/* prompt answer box */\n\n.prompt-answer-box .prompt-answer_layoutTop {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.prompt-answer-box,\n.prompt-question-box {\n  color: var(--primary-font-color);\n  font-size: 0.9rem;\n}\n\n.prompt-answer-box {\n  border-radius: 0.375rem;\n  margin-bottom: 2rem;\n}\n\n.prompt-answer-box:last-child {\n  margin-bottom: 0 !important;\n}\n\n.prompt-answer-box .prompt-answer-feedback {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 0rem;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n/* .prompt-question-box {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: flex-end;\n} */\n\n.prompt-question-box .go-back-btn {\n  min-width: 24px;\n  max-width: 24px;\n  min-height: 24px;\n  max-height: 24px;\n  border-radius: 50%;\n  margin-right: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.prompt-question-box .user-avatar {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-left: 1rem;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 50%;\n  margin-top: 0.25rem;\n}\n\n.prompt-question-box .prompt-question {\n  max-width: max-content;\n  justify-self: flex-end;\n  background-color: var(--tertiary-font-color);\n  padding: 0.75rem 1rem;\n  border-radius: 1rem;\n}\n\n.interactive-prompt {\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n/* sidebar css */\n\n.onedocai .ai-sidebar {\n  max-width: 300px;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  max-height: 100vh;\n  background-color: var(--sidemenu-background-color);\n}\n\n.ai-sidebar .ai-sidebar-top {\n  padding: 1rem;\n}\n\n.ai-sidebar .new-chat-btn {\n  width: 100%;\n  font-family: 'Inter', sans-serif;\n}\n\n/* new chat window */\n\n.new-chat-window {\n  user-select: none;\n}\n\n.interactive-answer.error .main-ai-response p {\n  margin: 0;\n  color: rgb(161, 22, 22) !important;\n  text-align: center;\n}\n\n.interactive-answer.error {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: red;\n  border-radius: 0.25rem;\n  padding: 0.5rem 1rem 0.5rem 1rem;\n}\n\n.interactive-answer.error .main-ai-response {\n  margin-bottom: 0rem !important;\n}\n\n.new-chat-window .new-chat-window-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.new-chat-window .chat-window-header {\n  padding-left: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.new-chat-window .chat-window-action {\n  padding: 0.25rem 0.5rem;\n  border-radius: 1rem;\n  margin-bottom: 0.25rem;\n  transition: all 250ms ease-in-out;\n  cursor: pointer;\n}\n\n.new-chat-window .chat-window-body h4 {\n  color: #000000;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  margin-bottom: 0.5rem;\n  text-align: left;\n  padding-top: 48px;\n}\n\n.chat-window-action .chat-window-action__layout {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.25rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.new-chat-window .chat-window-action:hover {\n  background-color: var(--tertiary-font-color);\n}\n\n.onedocai .main-chat-window {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  height: 100%;\n}\n\n.prompt-box-wrapper {\n  padding-bottom: 3rem;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n}\n\n/* onedoc sidebar all chats */\n.all-chats-btn {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  max-width: 200px;\n  line-height: 0.8rem;\n}\n\n.all-chats-drawer .ant-drawer-body {\n  padding: 0.5rem 1rem;\n}\n\n.all-chats-drawer .all-chats-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.75rem;\n}\n\n.all-chats-drawer .all-chats-header h3 {\n  margin: 0;\n}\n\n.responsive-chat-layout {\n  width: 100%;\n  height: 100%;\n  max-width: 700px;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.chat-menu-item {\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.25rem;\n}\n\n.chat-menu-item__inner {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-items: space-between;\n  gap: 0.25rem;\n}\n\n.chat-menu-item__inner .menu-item-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.chat-menu-item__inner .menu-item-label {\n  text-overflow: ellipsis;\n  text-wrap: nowrap;\n  overflow: hidden;\n  flex: 1;\n}\n\n.chat-menu-item__inner .menu-item-actions {\n  display: none;\n}\n.chat-menu-item:hover {\n  background-color: var(--tertiary-font-color);\n}\n\n.chat-menu-item:hover .menu-item-actions {\n  display: block;\n}\n\n.menu-item-actions .action-btn {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n/* onedocai header */\n\n.onedocai .onedocai-header {\n  padding: 0.5rem 1rem;\n}\n\n/* onedocai response css */\n.prompt-answer-box .prompt-answer .main-ai-response {\n  font-family: 'Inter', sans-serif;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  margin-bottom: 0.75rem;\n}\n\n.prompt-answer-box .prompt-answer .sources-list {\n  margin-top: 0;\n}\n\n.prompt-answer-box .prompt-answer .source-item p {\n  font-family: 'Inter', sans-serif;\n  margin: 0.25rem 0;\n  line-height: 1.4;\n}\n\n.prompt-answer-box .prompt-answer .source-item .source-item-link {\n  display: inline-block;\n  background-color: var(--tertiary-font-color);\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  font-size: 0.8rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.context-file-selector .dropdown-content {\n  position: absolute;\n  bottom: 40px;\n  right: 0px;\n  min-width: 180px;\n  max-width: 180px;\n  background-color: var(--tertiary-font-color) !important;\n  border-radius: 4px;\n}\n\n.context-file-selector .dropdown-content .node {\n  background-color: var(--tertiary-font-color) !important;\n}\n\n.context-file-selector .dropdown-trigger.arrow {\n  padding: 0.062rem 0.25rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border: none;\n  border-radius: 0.25rem;\n  background-color: var(--tertiary-font-color);\n  justify-content: flex-start;\n}\n\n.context-file-selector .dropdown .dropdown-trigger.arrow::after {\n  font-size: 8px;\n  border-color: var(--editor-text-font-color) !important;\n  color: var(--editor-text-font-color) !important;\n}\n\n.context-file-selector .tag-list {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.tag-list .tag {\n  text-wrap: nowrap;\n}\n\n.context-file-selector .dropdown-trigger input[type='text'] {\n  display: none;\n}\n.context-file-selector .dropdown-trigger .tag-item {\n  margin: 0;\n  margin-right: 4px;\n}\n\n.context-file-selector .tag {\n  background-color: var(--tag-onsurface-background-color);\n  padding: 0 0.125rem;\n  color: var(--editor-heading-font-color);\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.context-file-selector .tag button {\n  font-size: 14px;\n}\n\n.context-file-selector .dropdown-trigger .tag-item:last-of-type:after {\n  content: 'Select context';\n  text-wrap: nowrap;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--editor-text-font-color);\n}\n.prompt-answer_layoutBottom .remirror-editor {\n  font-size: 14px;\n}\n.prompt-answer_layoutBottom table {\n  width: 100% !important;\n}\n\n.ai-markdown table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1em;\n  font-size: 14px;\n}\n\n.ai-markdown th,\n.ai-markdown td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\n.ai-markdown th {\n  background-color: #f5f5f5;\n  font-weight: bold;\n}\n\n.ai-markdown tr:nth-child(even) {\n  background-color: #fafafa;\n}\n.prompt-question-box {\n  display: flex;\n  justify-content: flex-end;\n  padding: 4px 0;\n}\n\n.chat-bubble-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  max-width: 100%;\n  width: fit-content;\n}\n\n.chat-bubble {\n  background-color: #f2f2f2;\n  padding: 12px 16px;\n  border-radius: 16px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #000;\n  display: inline-block;\n  max-width: 100%;\n  white-space: pre-wrap;\n  max-width: 600px;\n  width: auto;\n}\n\n/* Chat actions under the bubble */\n.chat-actions {\n  margin-top: 4px;\n  display: flex;\n  /* gap: 4px; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
